export const localesMap: Record<string, string> = {
  "en-US": "en",
  "ar-SA": "ar",
  "de-DE": "de",
  "es-ES": "es",
  "fr-FR": "fr",
  "ja-JP": "jp",
  "id-ID": "id",
  "it-IT": "it",
  "ko-KR": "ko",
  "pt-BR": "pt",
  "ru-RU": "ru",
  "th-TH": "th",
  "tr-TR": "tr",
  "vi-VN": "vi",
  "zh-CN": "cn",
  "zh-TW": "tw",
};

export const languageToLocaleMap: Record<string, string> = {
  en: "en-US",
  ar: "ar-SA",
  de: "de-DE",
  es: "es-ES",
  fr: "fr-FR",
  jp: "ja-JP",
  id: "id-ID",
  it: "it-IT",
  ko: "ko-KR",
  pt: "pt-BR",
  ru: "ru-RU",
  th: "th-TH",
  tr: "tr-TR",
  vi: "vi-VN",
  cn: "zh-CN",
  tw: "zh-TW",
};

export const availableLanguages = Object.values(languageToLocaleMap);
